import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

type EmbedVideoResponse = {
    [key: string]: any;
    description: string;
    thumbnail_url?: string;
};

@Injectable()
export class VideoPlayerService {
    private http: HttpClient = inject(HttpClient);
    private videoCacheDetails: { [key: string]: EmbedVideoResponse } = {};

    public getVimeoVideoDetails(videoId?: string): Observable<EmbedVideoResponse> {
        if (!videoId) {
            console.warn('Video id not found');
            return of({ description: 'Video id not found' } as EmbedVideoResponse);
        }

        if (this.videoCacheDetails[videoId]) {
            return of(this.videoCacheDetails[videoId]);
        }

        const videoUrl = `https://vimeo.com/${videoId}`;
        return this.http
            .get<EmbedVideoResponse>(`https://vimeo.com/api/oembed.json?url=${videoUrl}`)
            .pipe(tap((videoDetails: EmbedVideoResponse) => (this.videoCacheDetails[videoId] = videoDetails)));
    }

    public getYoutubeVideoId(url?: string): string {
        if (!url) {
            console.warn('Url not found');
            return '';
        }

        // this will look at the url if theres is some, and get the video id
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const match = url.match(regExp);

        if (!match) {
            return url;
        }

        // and check if the id has exacly 11 chars to be valid
        return match && match[7].length === 11 ? match[7] : '';
    }
}
